module.exports = __webpack_public_path__ + "img/QRIS.0ebe951a.svg";